import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { AgentV2ConversationsActions } from '@/agent-v2/conversations/store/slice'
import type { PaxtonSkill, UserSkill } from '@/user-skills/schemas'

type UserSkillLibraryState = {
  skills: UserSkill[]
  paxtonSkills: PaxtonSkill[]
  loaded: boolean
  loading: boolean
  loadError: boolean
}

const initialState: UserSkillLibraryState = { skills: [], paxtonSkills: [], loaded: false, loading: false, loadError: false }

const userSkillLibrarySlice = createSlice({
  name: 'userSkillLibraryState',
  initialState,
  reducers: {
    refreshLibrary: (_state, _action: PayloadAction<{ force: boolean }>) => {},
    loadStarted: (state) => {
      state.loading = true
      state.loadError = false
    },
    loadSucceeded: (state, action: PayloadAction<{ skills: UserSkill[]; paxtonSkills: PaxtonSkill[] }>) => {
      state.skills = action.payload.skills
      state.paxtonSkills = action.payload.paxtonSkills
      state.loaded = true
      state.loading = false
    },
    loadFailed: (state) => {
      state.loading = false
      state.loadError = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(AgentV2ConversationsActions.nullifyData, () => initialState)
  },
})

export const UserSkillLibraryActions = userSkillLibrarySlice.actions
export default userSkillLibrarySlice.reducer
